import FanMassDeleteModal from './FanMassDeleteModal';

export default FanMassDeleteModal;
